import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Box
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import api from '../../api/api';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

const CreateEditEmployeeDialog = ({ open, handleClose, employee, onSave }) => {
  const [formValues, setFormValues] = useState({
    employeeCode: '',
    name: '',
    joiningDate: null,
    departmentId: '',
    designation: ''
  });
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    if (employee) {
      setFormValues({
        id: employee.id,
        employeeCode: employee.employeeCode || '',
        name: employee.name || '',
        joiningDate: employee.joiningDate ? dayjs(employee.joiningDate) : null,
        departmentId: employee.departmentId || '',
        designation: employee.designation || ''
      });
    } else {
      setFormValues({
        employeeCode: '',
        name: '',
        joiningDate: null,
        departmentId: '',
        designation: ''
      });
    }
  }, [employee]);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await api.get('/api/Departments');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleDateChange = (date) => {
    setFormValues({
      ...formValues,
      joiningDate: date,
    });
  };

  const handleSubmit = async () => {

    const formattedValues = {
      ...formValues,
      joiningDate: formValues.joiningDate ? formValues.joiningDate.format('YYYY-MM-DD') : null,
    };

    if (employee) {
      await api.put(`/api/Employees/${employee.id}`, formattedValues);
    } else {
      await api.post('/api/Employees', formattedValues);
    }
    onSave();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <form onSubmit={e => {
        e.preventDefault();
        handleSubmit();
      }}>
        <DialogTitle>{employee ? 'Update Employee' : 'Create Employee'}</DialogTitle>
        <DialogContent>
          <Box>
            <TextField
              margin="dense"
              name="employeeCode"
              label="Employee Code"
              type="text"
              fullWidth
              value={formValues.employeeCode}
              onChange={handleInputChange}
              inputProps={{ required: true }}
            />
            <TextField
              margin="dense"
              name="name"
              label="Name"
              type="text"
              fullWidth
              value={formValues.name}
              onChange={handleInputChange}
              inputProps={{ required: true }}
            />
            <LocalizationProvider fullWidth dateAdapter={AdapterDayjs} adapterLocale="en-gb">

              <DatePicker
                name="joiningDate"
                value={formValues.joiningDate}
                sx={{ width: '100%', marginY: 1 }}
                disableFuture
                inputProps={{ required: true }}
                onChange={handleDateChange}
                label="Joining Date"
                fullWidth
              />

            </LocalizationProvider>

            <TextField
              margin="dense"
              label="Department"
              name="departmentId"
              value={formValues.departmentId}
              onChange={handleInputChange}
              inputProps={{ required: true }}
              fullWidth
              select
            >
              {departments.map((department) => (
                <MenuItem key={department.id} value={department.id}>
                  {department.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              margin="dense"
              name="designation"
              label="Designation"
              type="text"
              fullWidth
              value={formValues.designation}
              onChange={handleInputChange}
              inputProps={{ required: true }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type='submit' variant="contained" color="primary">
            {employee ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateEditEmployeeDialog;
